import { render, staticRenderFns } from "./GroupMembersEdit.vue?vue&type=template&id=60af1070&scoped=true&"
import script from "./GroupMembersEdit.vue?vue&type=script&lang=js&"
export * from "./GroupMembersEdit.vue?vue&type=script&lang=js&"
import style0 from "./GroupMembersEdit.vue?vue&type=style&index=0&id=60af1070&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60af1070",
  null
  
)

export default component.exports